import moment from 'moment';

export const GenericDate = (value: string) => value && moment(value).format('M/D/YY');
export const GenericDateTime = (value: string) => value && moment(value).format('L LTS');
